// src/components/AGTFit/service/fatsecretService.js
import axios from 'axios';
 
// Determinar la URL base del API según el entorno
const API_BASE = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5003'
  : (process.env.REACT_APP_API_FIT_URL);
 
// Prefijo de API según entorno
const API_PREFIX = process.env.NODE_ENV === 'development' ? '/api' : '';
 
// URL completa para el proxy
const PROXY_URL = `${API_BASE}${API_PREFIX}/proxy`;
 
// Variable para almacenar el token actual
let currentToken = null;
let tokenExpiration = null;
 
// Función para obtener un token OAuth 2.0
const getAccessToken = async () => {
  // Si ya tenemos un token válido, lo devolvemos
  if (currentToken && tokenExpiration && new Date() < tokenExpiration) {
    return currentToken;
  }
 
  try {
 
    // Solicitar nuevo token a través de nuestro proxy
    const response = await axios.post(`${PROXY_URL}/token`, {}, {
      withCredentials: false // Importante: no enviar cookies para evitar problemas CORS
    });
 
    if (response.data.success && response.data.data) {
      // Guardar el token y calcular su expiración
      currentToken = response.data.data.access_token;
      const expiresIn = response.data.data.expires_in;
      tokenExpiration = new Date(new Date().getTime() + expiresIn * 1000);
      return currentToken;
    } else {
      console.error('Token response did not contain expected data:', response.data);
      throw new Error('Failed to obtain token: Invalid response format');
    }
  } catch (error) {
    console.error('Error obtaining FatSecret access token:', 
      error.response?.data || error.message);
    throw error;
  }
};
 
// Función para realizar solicitudes a la API
const apiRequest = async (method, params) => {
  try {
    const token = await getAccessToken();
 
    const response = await axios.post(`${PROXY_URL}/api`, {
      token,
      method,
      params
    }, {
      withCredentials: false // Importante: no enviar cookies para evitar problemas CORS
    });

    return response.data;
  } catch (error) {
    console.error('FatSecret API request error:', 
      error.response?.data || error.message);
    throw error;
  }
};
 
const fatsecretService = {
  // Buscar alimentos por texto
  searchFoods: async (query, page = 0, maxResults = 20) => {
    try {
        const response = await apiRequest('foods.search.v3', {
        search_expression: query,
        page_number: page,
        max_results: maxResults
        });
    
        if (response.success && response.data.foods_search) {
    
        const foods = response.data.foods_search.results?.food || [];
    
        return { 
            success: true, 
            data: foods,
            total_results: response.data.foods_search.total_results || 0,
            page_number: response.data.foods_search.page_number || 0,
            max_results: response.data.foods_search.max_results || 20
        };
        }
    
        return { success: true, data: [] };
    } catch (error) {
        console.error('Error al buscar alimentos en FatSecret:', error);
        return { success: false, error: error.message };
    }
    },

  // Obtener detalles de un alimento por ID
  getFoodDetails: async (foodId) => {
    try {
      const response = await apiRequest('food.get.v2', {
        food_id: foodId
      });
      
      if (response.success && response.data.food) {
        return { success: true, data: response.data.food };
      }
      
      return { success: false, error: 'Food details not found' };
    } catch (error) {
      console.error('Error al obtener detalles de alimento en FatSecret:', error);
      return { success: false, error: error.message };
    }
  },

  // Buscar un alimento por código de barras
  scanBarcode: async (barcode) => {
    try {
      const response = await apiRequest('food.find_id_for_barcode', {
        barcode: barcode
      });
      
      if (response.success && response.data.food_id) {
        // Si encontramos el ID, obtenemos los detalles del alimento
        return await fatsecretService.getFoodDetails(response.data.food_id);
      }
      
      return { success: false, error: 'Barcode not found' };
    } catch (error) {
      console.error('Error al escanear código de barras en FatSecret:', error);
      return { success: false, error: error.message };
    }
  },
  
  // Autocompletar nombres de alimentos
  autocompleteFood: async (query, max_results = 10) => {
    try {
      const response = await apiRequest('foods.autocomplete.v2', {
        expression: query,
        max_results: max_results
      });
      
      if (response.success && response.data.suggestions) {
        return { 
          success: true, 
          data: response.data.suggestions.suggestion || [] 
        };
      }
      
      return { success: true, data: [] };
    } catch (error) {
      console.error('Error al autocompletar alimentos en FatSecret:', error);
      return { success: false, error: error.message };
    }
  },
  
  // Obtener categorías de alimentos
  getFoodCategories: async () => {
    try {
      const response = await apiRequest('food_categories.get.v2', {});
      
      if (response.success && response.data.food_categories) {
        return { 
          success: true, 
          data: response.data.food_categories.food_category || [] 
        };
      }
      
      return { success: true, data: [] };
    } catch (error) {
      console.error('Error al obtener categorías de alimentos en FatSecret:', error);
      return { success: false, error: error.message };
    }
  }
};

export default fatsecretService;